export default function Step2() {
  return (
    <div className="flex size-full flex-col items-center overflow-hidden text-center">
      <div className="size-full max-h-[370px] overflow-hidden">
        <img
          alt="image"
          src="https://storage.googleapis.com/educabot-aec-cdn-1/tich/images/explanatory-modal/step-2.gif"
          className="block size-full max-h-full max-w-full overflow-hidden bg-transparent object-contain"
        />
      </div>
      <div className="w-full shrink-0 overflow-hidden">
        <p className="my-5 text-sm font-normal h-768:text-xl">
          A medida que pasa el tiempo te olvidás todo...
        </p>
        <p className="animate-fade-in text-sm font-bold h-768:text-xl">
          ¡Pero hay una forma de evitarlo!
        </p>
      </div>
    </div>
  )
}
